import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
interface MobileLayoutProps {
  children: React.ReactNode;
}
export function MobileLayout({
  children
}: MobileLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-background" data-id="element-131">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} data-id="element-132" />

      <div className="lg:ml-64" data-id="element-133">
        <Header onMenuClick={() => setIsSidebarOpen(true)} data-id="element-134" />

        <main className="p-4 lg:p-8 pb-safe" data-id="element-135">{children}</main>
      </div>
    </div>;
}